<script setup lang="ts">
import {ref} from "vue";
import {Aperture, Car, CheckCircle, Paintbrush, Plus, Shield, ShoppingBag, Truck, Wrench, Zap,} from "lucide-vue-next";

import '@/assets/styles/service.css';

interface Service {
  title: string;
  services: string[];
  icon: any; // Icon Component
}

const selected = ref<Service | null>(null);

const services: Service[] = [
  {
    title: "Wartung & Reparatur",
    icon: Wrench,
    services: [
      "Inspektionen nach Herstellervorgaben (inkl. Serviceheftpflege / digitaler Serviceeintrag)",
      "Ölwechsel & Flüssigkeitsservice (Motoröl, Bremsflüssigkeit, Kühlmittel, Servolenkung)",
      "Bremsenservice (Bremsbeläge, Bremsscheiben, Bremsprüfung)",
      "Motor- und Getriebereparaturen (inkl. Fehlerdiagnose und Instandsetzung)",
      "Getriebeölspülung (für Automatikgetriebe zur Lebensdauerverlängerung)",
      "Auspuff- und Fahrwerksarbeiten (Stoßdämpfer, Federn, Querlenker etc.)",
      "Elektronik- & Diagnoseservice (Fehlerspeicher auslesen, Steuergeräte-Diagnose)",
    ],
  },
  {
    title: "Ergänzende Leistungen",
    icon: Plus,
    services: [
      "Windschutzscheiben-Reparatur & Austausch",
      "Batterieservice (Prüfung, Austausch, Start-/Stopp-Batterien)",
      "Klimaanlagenservice (Wartung, Desinfektion, Kältemittel-Service)",
      "Zahnriemen- & Kettenservice",
    ],
  },
  {
    title: "Fahrzeugverkauf & Beratung",
    icon: Car,
    services: [
      "Verkauf von Gebrauchtwagen",
      "Inzahlungnahme von Altfahrzeugen",
    ],
  },
  {
    title: "Karosserie & Lack",
    icon: Paintbrush,
    services: [
      "Unfallreparaturen",
      "Lackierungen und Smart Repair",
      "Rostschutz und Versiegelung",
    ],
  },
  {
    title: "Reifenservice",
    icon: Aperture,
    services: [
      "Reifenwechsel (Sommer-/Winterreifen)",
      "Einlagerung von Reifen",
      "Auswuchten der Räder",
      "Reifenreparatur",
      "Montage von Reifen auf Felgen",
      "RDKS-Service",
      "Reifenprüfung & Beratung",
    ],
  },
  {
    title: "Prüfungen & Zulassung",
    icon: CheckCircle,
    services: [
      "Hauptuntersuchung (HU) & Abgasuntersuchung (AU)",
      "Fahrzeugzulassung und Abmeldung",
      "Sicherheitschecks",
    ],
  },
  {
    title: "Firmenfahrzeuge",
    icon: Shield,
    services: [
      "UVV-Prüfung nach DGUV Vorschrift 70",
      "Dokumentation und Prüfprotokolle",
    ],
  },
  {
    title: "Spezielle Dienstleistungen",
    icon: Zap,
    services: [
      "Klimaanlagenservice",
      "Nachrüstung von Zubehör (z. B. Anhängerkupplung, Navi)",
    ],
  },
  {
    title: "Zusatzservices",
    icon: Truck,
    services: [
      "Ersatzwagen / Mietwagen",
      "Hol- und Bringservice",
    ],
  },
  {
    title: "Ersatzteile & Zubehör",
    icon: ShoppingBag,
    services: [
      "Original- und Ersatzteile",
      "Verschleißteile (Bremsen, Filter, Batterien)",
      "Zubehör (Fußmatten, Dachträger, Pflegeprodukte)",
      "Nachrüstungen",
      "Beratung zu passenden Teilen",
    ],
  },
  /*{
    name: "Wartungsarbeiten & Reparaturen",
    details:
        "Inspektionen nach Herstellervorgaben (inkl. Serviceheftpflege / digitaler Serviceeintrag), Ölwechsel & Flüssigkeitsservice (Motoröl, Bremsflüssigkeit, Kühlmittel, Servolenkung), Bremsenservice (Bremsbeläge, Bremsscheiben, Bremsprüfung), Motor- und Getriebereparaturen (inkl. Fehlerdiagnose und Instandsetzung), Getriebeölspülung (für Automatikgetriebe zur Verlängerung der Lebensdauer und Verbesserung des Schaltverhaltens), Auspuff- und Fahrwerksarbeiten (Stoßdämpfer, Federn, Querlenker etc.), Elektronik- & Diagnoseservice (Fehlerspeicher auslesen, Steuergeräte-Diagnose)",
    icon: Wrench,
  },
  {
    name: "Fahrzeugdiagnose",
    details: "Fehlerspeicher auslesen, Software-Updates, Überprüfung von Motor- und Sicherheitssystemen",
    icon: NotebookText,
  },
  {
    name: "Glasschäden",
    details: "Steinschlagreparatur, Scheibenaustausch bei Schäden",
    icon: Framer,
  },
  {
    name: "HU / AU (TÜV)",
    details: "Vorbereitung und Durchführung der gesetzlich vorgeschriebenen Prüfungen",
    icon: CheckCircle,
  },
  {
    name: "Ersatzteile & Zubehör",
    details: "Originalteile und Zubehör für Ihr Fahrzeug, Fairer und zuverlässiger Verkauf",
    icon: ShoppingBag,
  },
  {
    name: "Gebrauchtwagen Ankauf & Verkauf",
    details: "Kauf von Gebrauchtwagen Verkauf von Gebrauchtwagen",
    icon: Car,
  },
  {
    name: "Zusatzleistungen",
    details: "HU/AU Vorbereitung, Fahrzeugaufbereitung / PflegeAchsvermessung",
    icon: Layers,
  },*/
];

const showPopup = (service: Service) => {
  selected.value = service;
};

const closePopup = () => {
  selected.value = null;
};

// Hilfsfunktion für Liste im Template
const detailsList = (details: string) =>
    details.split(",").map(d => d.trim()).filter(d => d.length > 0);

</script>

<template>
  <Toast/>
  <div class="services">

    <section class="features">
      <div class="feature-wrapper">
        <h1>Dienstleistungen</h1>

        <div class="feature-grid">
          <div
              class="feature-card"
              v-for="service in services"
              :key="service.title"
              @click="showPopup(service)"
          >
            <component :is="service.icon" class="feature-icon"/>
            <h3>{{ service.title }}</h3>
          </div>
        </div>

      </div>
    </section>

    <!-- POPUP -->
    <div v-if="selected" class="popup-overlay" @click.self="closePopup">
      <div class="popup-box">
        <button class="close-btn-service" type="button" aria-label="Popup schliessen" @click="closePopup">x</button>
        <component :is="selected.icon" class="popup-icon"/>
        <h2>{{ selected.title }}</h2>

        <ul class="popup-list">
          <li v-for="detail in selected.services" :key="detail">
            {{ detail }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
